import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { useRouteMatch } from 'react-router';

import { SmaCampaignDrawer } from 'src/components';
import { useCampaignApi, useProjectApi } from 'src/services';
import { SmaCampaignRoutes } from 'src/scenes/Project/scenes/Campaign/SmaCampaignRoutes';


const mainDrawerWidth = 97;
const drawerWidth = 240;

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: `calc(100% - ${drawerWidth + mainDrawerWidth}px)`,
  },
  maxMainContainer: {
    width: '100%',
  },
}));

const SmaCampaignContainer = () => {

  const classes = useStyles();
  const match = useRouteMatch();
  const campaignApi = useCampaignApi();
  const projectApi = useProjectApi();

  const { projectId, campaignId } = match.params;

  const [ isOpenDrawer, setIsOpenDrawer ] = useState(true);
  const [ campaign, setCampaign ] = useState({ name: '', titleHolder: '' });
  const [ project, setProject ] = useState({});

  const toggleDrawer = () => setIsOpenDrawer(prevState => !prevState);

  useEffect(() => {
    const fetchData = async () => {
      const [ [ campaign ], { projectList } ] = await Promise.all([
        campaignApi.getCampaign(campaignId),
        projectApi.getProject(projectId),
      ]);
      const project = projectList.pop();
      const isSite = Boolean(project?.parentId);
      setCampaign(campaign);
      setProject({
        siteName: isSite ? project.name : undefined,
        siteId: isSite ? project.id : undefined,
        name: isSite ? project.parentName : project.name,
        id: isSite ? project.parentId : project.id,
      });
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ campaignId ]);
  useEffect(() => {
    document.title = campaign ? `${campaign.name} - Nviro Monitor` : 'Nviro Monitor';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ campaign.name ]);

  return (
    <>
      <SmaCampaignDrawer
        width={drawerWidth}
        isOpenDrawer={isOpenDrawer}
        actions={{ toggleDrawer }}
        campaignId={campaignId}
        campaignName={campaign.name}
        isBaseline={campaign.isBaseline}
      />
      <Box className={isOpenDrawer ? classes.mainContainer : classes.maxMainContainer}>
        <SmaCampaignRoutes campaign={campaign} project={project}/>
      </Box>
    </>
  );
};


export { SmaCampaignContainer };
